export default class AccountRoleType {
    static USER = 0;
    static EXECUTOR = 1;
    static ADMIN = 2;
}
